import { ParcConfigDto } from "api/real-estate";
import { createContext, ReactNode, useContext } from "react";

import { usePricingParc } from "../hooks/usePricingParc";

interface PricingParcContextValue {
  isParc: boolean;
  config?: ParcConfigDto;
  isLoading: boolean;
  refetch: () => void;
}

const PricingParcContext = createContext<PricingParcContextValue | undefined>(undefined);

/**
 * Charge la config de couverture du parc UNE seule fois et la partage (en-tête + carte parc),
 * pour éviter les doubles fetch et garder `isParc`/config cohérents après un enregistrement.
 */
export const PricingParcProvider: React.FC<{ riskId: string; children: ReactNode }> = ({ riskId, children }) => {
  const value = usePricingParc(riskId);
  return <PricingParcContext.Provider value={value}>{children}</PricingParcContext.Provider>;
};

export const usePricingParcContext = (): PricingParcContextValue => {
  const ctx = useContext(PricingParcContext);
  if (!ctx) throw new Error("usePricingParcContext must be used within a PricingParcProvider");
  return ctx;
};
